import { TYPE as coreTYPE } from '../../Core.constants';
import { ICON } from '../helpers';

const { CHAIN, HOTEL } = coreTYPE;

const PLACES_LENGTH_LIMIT = 10;

const FIELD = {
  PLACE: {
    icon: ICON.LOCATION,
  },
  CALENDAR: {
    icon: ICON.CALENDAR,
  },
  OCCUPATION: {
    icon: ICON.PEOPLE,
  },
  PROMOCODE: {
    icon: ICON.PROMO,
    inputMode: true,
  },
};

const VIEW = {
  PLACE: 'place',
  CALENDAR: 'calendar',
  OCCUPATION: 'occupation',
  PROMOCODE: 'promocode',
};

const TYPE = {
  CHAIN,
  HOTEL,
};

export { FIELD, PLACES_LENGTH_LIMIT, TYPE, VIEW };
